import(/* webpackMode: "eager" */ "/home/interim/frontend/app/about/page.tsx");
